module.exports = __webpack_public_path__ + "img/NoRecording.42728437.svg";